/* eslint-disable */
import { Modal, Button } from "react-bootstrap"; // Using Bootstrap Modal for simplicity

import React, { useContext, useEffect , useState} from 'react'
import io from 'socket.io-client'
import notificationSound from '../../assets/notifications.mp3' // Add your sound file
import { storeLoginData, getLoginData, removeLoginData, isLoggedIn } from '../../utils/loginSession'
const socket = io(process.env.REACT_APP_BASE_URL_NEW)

const NewOrderNotification = () => {
  const [newOrder, setNewOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);
  // const [audio] = useState(new Audio(notificationSound));
const [audio, setAudio] = useState(null);

useEffect(() => {
  const unlock = () => {
    const a = new Audio(notificationSound);
    a.load();
    setAudio(a);
  };

  document.addEventListener("touchstart", unlock, { once: true });
  document.addEventListener("click", unlock, { once: true });
}, []);

  const loginData = getLoginData(); // Your function to check login state
  useEffect(() => {
    

    if (!loginData) return;
    
    socket.emit('joinRoom', getLoginData()?.restaurant?._id)
    socket.on('newOrder', (details) => {
      playSound()
      setNewOrder(details);
      setShowModal(true);

      console.log('New Order', details)
    })
    return () => socket.off('newOrder')
  }, [loginData])

  const playSound = () => {
    // const audio = new Audio(notificationSound)
    audio.play()
  }

  const handleAccept = () => {
    // Handle accept action
    hideNotification()
  }

  const handleReject = () => {
    // Handle reject action
    hideNotification()
  }

  return (
    <>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>New Order Alert 🚀</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>A new order has been placed!</p>
          <strong>Order ID:</strong> {newOrder?._id} <br />
          <strong>Customer:</strong> {newOrder?.userId?.full_name} <br />
          <strong>Total:</strong> ${newOrder?.totalAmount}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => (window.location.href = '/order/all-orders')}>
            View Orders
          </Button>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default NewOrderNotification
